import React, { useState } from 'react';
import CreditCardForm from '../payment/CreditCardForm';
import { isCanadianClient, isDomesticRequisitionType, isShippingToCanada, isUKOrder } from '../util/gearOrderUtil';
import AcceptedCreditCards from './AcceptedCreditCards';

export default function ExpeditedShippingPayment({
	userInfo,
	gearOrder,
	paymentDetails,
	handlePaymentInputChange,
	onSubmit,
	onShippingEdit
}) {
	const hasCardOnFile = userInfo?.type === 'myGDX' && !!gearOrder?.practitioner?.shippingCardOnFile;
	const [useCardOnFile, setUseCardOnFile] = useState(hasCardOnFile);

	if (
		(!gearOrder.expeditedShippingCharge && !gearOrder.expeditedShippingPayment?.cardAuthAmount) ||
		userInfo.type !== 'myGDX'
	) {
		return null;
	}

	const canadaClient = isCanadianClient(gearOrder);
	const shippingToCanada = isShippingToCanada(gearOrder) || canadaClient;
	const isInternational = !isDomesticRequisitionType(gearOrder);
	const charge = gearOrder.expeditedShippingPayment?.cardAuthAmount || gearOrder.expeditedShippingCharge;

	const selectCardOnFile = () => {
		setUseCardOnFile(true);
		updateTokenId(true);
	};

	const selectNewCard = () => {
		setUseCardOnFile(false);
		updateTokenId(false);
	};

	const updateTokenId = (useCardOnFile) => {
		const event = {
			target: {
				value: useCardOnFile ? '9999A' : '',
				name: 'tokenId',
				type: ''
			}
		};

		handlePaymentInputChange(event);
	};

	const ukOrder = isUKOrder(gearOrder);
	return (
		<div>
			<h3 className="mt-0">
				{shippingToCanada ? 'Shipping Charges' : 'Expedited Shipping Charges'}
				<p className="small">Shipping charges must be paid upon confirmation of this order</p>
			</h3>
			<h4>
				{gearOrder.shippingMethod}: {charge.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
				{!gearOrder.expeditedShippingPayment && onShippingEdit && !shippingToCanada && (
					<button type="button" title="edit" className="btn btn-edit btn-primary" onClick={onShippingEdit}>
						Edit
					</button>
				)}
			</h4>
			{!!gearOrder.expeditedShippingPayment ? (
				<h4>Confirmation Code: {gearOrder.expeditedShippingPayment?.transactionId}</h4>
			) : (
				<>
					{hasCardOnFile && (
						<>
							<div className="radio">
								<label htmlFor="expedited-cardOnFile">
									<input
										id="expedited-cardOnFile"
										name="paymentType"
										type="radio"
										value="cardOnFile"
										onChange={selectCardOnFile}
										defaultChecked={useCardOnFile}
									/>
									Use my saved Shipping Card on file
								</label>
							</div>
							<div className="radio">
								<label htmlFor="expedited-newCard">
									<input
										id="expedited-newCard"
										name="paymentType"
										type="radio"
										value="newCard"
										onChange={selectNewCard}
										defaultChecked={!useCardOnFile}
									/>
									Enter a new Credit Card
								</label>
							</div>
						</>
					)}

					{!useCardOnFile && (
						<>
							<CreditCardForm
								handlePaymentInputChange={handlePaymentInputChange}
								onSubmit={onSubmit}
								paymentDetails={paymentDetails}
								isInternational={isInternational}
								acceptedCards={<AcceptedCreditCards isUkClient={ukOrder} />}
							/>
							{(canadaClient || hasCardOnFile) && (
								<div className="checkbox mt-0 mb-0">
									<label>
										<input
											type="checkbox"
											name="saveForLater"
											defaultChecked={paymentDetails?.saveForLater?.value}
											onChange={handlePaymentInputChange}
										/>
										{hasCardOnFile ? (
											<strong> Update saved Shipping Card on file</strong>
										) : (
											<strong> Save card for future shipping charges</strong>
										)}
									</label>
								</div>
							)}
						</>
					)}
				</>
			)}
		</div>
	);
}
